import {createContext, h} from 'preact'
import {useEffect, useState} from "preact/hooks";
import App from "../components/app";
import {getLocations, getPopularStylists, getSalons} from "../data-providers/common-data-provicer";
import {route} from "preact-router";
import {PER_PAGE_OPTION} from "../constants/settings";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {scrollToTop} from "../utils/functions";


export const HomeContext = createContext({open: false, setOpen: null});

const defaultContex = {
    openedPopup: false,
    locations: [],
    availableCountries: [],
    mainCities: [],
    popupName: '',
    service: null,
    country: null,
    city: null,
    area: null,
    searchText: '',
    salons: [],
    page: 1,
    maxPage: 1,
    searchResultsLoaded: false,
    isNigeria: true,
}

export default () => {

    const [context, setContext] = useState(defaultContex)
    const [popularStylists, setPopularStylists] = useState([])

    const {executeRecaptcha} = useGoogleReCaptcha();
    const handleReCaptchaVerify = async () => {
        return  await executeRecaptcha('searchSubmit');

    };


    const setSearch = (search) => {
        if (!search) {
            setContext({...context, searchText: ''});
            return;
        }
        const updatedContext = {
            ...context,
            searchText: search,
            openedPopup: false,
            popupName: '',
            page: 1,
            salons: [],
        }

        handleReCaptchaVerify().then(token => getSalonsList(updatedContext, token))

    }

    const getSalonsList = async (params, token = '', cityId = null) => {
        if (params.page === 1) scrollToTop();
        setContext({...params, searchResultsLoaded: false, popupName: '', openedPopup: false})
        route('/stylists')
        const res = await getSalons(params.country?.id, cityId || params.city?.id, params.area?.id, params.service?.categorySlug, params.searchText, params.page, PER_PAGE_OPTION, token);
        setContext({...params,
            salons: [...new Map(params.salons.concat(res.data).map(item =>
                [item['stylist_id'], item])).values()],
            maxPage: res.meta.last_page,
            searchResultsLoaded: true
        });

    }

    const setCountry = (co) => {
        setContext({
            ...context,
            page: 1,
            salons: [],
            country: co,
            isNigeria: co.name !== 'Ghana',
            popupName: 'cities',
            city: null,
            area: null,
            openedPopup: true,
        })
    }
    const setCity = (c) => {
        const updatedContext = {
            ...context,
            page: 1,
            searchText: '',
            salons: [],
            city: c,
            area: null,
        }
        if (c.areas.length) {
            updatedContext.popupName = 'areas'
            updatedContext.openedPopup = true
            setContext(updatedContext)
        } else {
            updatedContext.popupName = '';
            updatedContext.openedPopup = false;
            setContext(updatedContext)
            getSalonsList(updatedContext)
        }

    }
    const setArea = (a) => {
        const updatedContext = {
            ...context,
            page: 1,
            salons: [],
            popupName: '',
            openedPopup: false,
            area: a
        }
        setContext(updatedContext)
        getSalonsList(updatedContext)
    }

    const setService = (service) => {
        const updatedContext = {
            ...context,
            searchText: '',
            page: 1,
            salons: [],
            service
        }

        if (context.locations.length > 1 && !context.country) {
            updatedContext.popupName = 'countries';
        } else if (!context.country) {
            updatedContext.country = context.locations[0];
            updatedContext.popupName = 'cities'

        } else {
            updatedContext.popupName = '';
            updatedContext.openedPopup = false
            getSalonsList(updatedContext)
        }
        setContext(updatedContext)
    }

    const findInCapital = (capital) => {
        let  city;
        if (capital === 'Lagos') {
            city = context.mainCities.filter((el) => el.name === 'Lagos')[0]
        } else {
            city = context.mainCities.filter((el) => el.name === 'Accra')[0]
        }
        const updatedContext = {
            ...context,
            city,
            page: 1,
            salons: [],
            openedPopup: false,
            popupName: '',
            service: null,
            area: null
        }
        getSalonsList(updatedContext)

    }

    useEffect(() => {
        getPopularStylists().then((res) => setPopularStylists(res.data))
        getLocations().then((loc) => {
            let isNigeria = true;
            if (context.country?.name === 'Ghana' || (loc.locations.length === 1 && loc.locations[0].name === 'Ghana')) {
                isNigeria = false
            }
            setContext({...context, locations: loc.locations, isNigeria, availableCountries: loc.availableCountries, mainCities: loc.mainCities})
        });
    }, []);

    const openPopup = (popupTitle) => {
        setContext({
            ...context,
            openedPopup: true,
            popupName: popupTitle
        })
    }

    const closePopup = () => {
        setContext({
            ...context,
            openedPopup: false,
            popupName: ''
        })
    }

    const increasePage = () => {
        if (context.page >= context.maxPage) {
            return ;
        }
        const updatedContext = {
            ...context,
            page: context.page + 1
        }
        setContext(updatedContext)
        getSalonsList(updatedContext)
    }

    return (
        <HomeContext.Provider value={{
            increasePage,
            setService,
            setCountry,
            setCity,
            setArea,
            openPopup,
            closePopup,
            setSearch,
            findInCapital,
            popularStylists,
            ...context,
            setContext
        }}>
            <App />
        </HomeContext.Provider>
    )
}